import { ChakraProvider, Flex, Box } from "@chakra-ui/react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import DashboardContent from "./components/DashboardContent";
import Cameras from "./components/Cameras";
import Machines from "./components/Machines";
import Faces from "./components/Faces";
import Login from "./components/Login";
import Users from "./components/Users";
import PrivateRoute from "./components/PrivateRoute";
import Algorithms from "./components/Algorithms";
import VehiclePassages from "./components/VehiclePassages";
import TrafficMap from "./components/TrafficMap";
import Fiscalization from "./components/Fiscalization";
// Importar o novo componente modularizado
import InfractionsMain from "./components/infractions/InfractionsMain";
import Batches from "./components/Batches";
import Settings from "./components/Settings";
import SessionExpiredModal from "./components/SessionExpiredModal";

function App() {
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const handleAuthExpired = () => setSessionExpired(true);
    window.addEventListener('auth:expired', handleAuthExpired);
    return () => window.removeEventListener('auth:expired', handleAuthExpired);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    window.location.href = '/dashboard';
  };

  const handleLogout = async () => {
    const token = localStorage.getItem('token');

    try {
      if (token) {
        await fetch('/api/auth/logout', {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` }
        });
      }
    } catch (error) {
      console.error('Erro ao registrar logout:', error);
    } finally {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
  };

  return (
    <ChakraProvider>
      <SessionExpiredModal isOpen={sessionExpired} />
      <Router>
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <DashboardContent />
              </Box>
            </Flex>
          )} />} />
          <Route path="/machines" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Machines />
              </Box>
            </Flex>
          )} />} />
          <Route path="/cameras" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Cameras />
              </Box>
            </Flex>
          )} />} />
          <Route path="/faces" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Faces />
              </Box>
            </Flex>
          )} />} />
          <Route path="/users" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Users />
              </Box>
            </Flex>
          )} />} />
          <Route path="/algorithms" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Algorithms />
              </Box>
            </Flex>
          )} />} />
          <Route path="/passages" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <VehiclePassages />
              </Box>
            </Flex>
          )} />} />
          <Route path="/map" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <TrafficMap />
              </Box>
            </Flex>
          )} />} />
          <Route path="/fiscalization" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Fiscalization />
              </Box>
            </Flex>
          )} />} />
          {/* Atualizar a rota de infrações para usar o novo componente */}
          <Route path="/infractions" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <InfractionsMain />
              </Box>
            </Flex>
          )} />} />
          <Route path="/batches" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Batches />
              </Box>
            </Flex>
          )} />} />
          <Route path="/settings" element={<PrivateRoute element={() => (
            <Flex>
              <Sidebar onLogout={handleLogout} />
              <Box ml="250px" flex="1" minH="100vh">
                <Settings />
              </Box>
            </Flex>
          )} />} />
          <Route path="/access-logs" element={<Navigate to="/users" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;